var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRailcard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM6.45865 6.18785L12.3478 8.97272H2.74031V10.8291H12.3528L7.48816 13.1274H2.74031V14.9838H7.61527L13.5911 17.6925H17.4734L11.7522 14.9838H21.1271V13.1274H11.6378L16.5025 10.8291H21.1271V8.97272H16.4797L10.4765 6.25013L6.45865 6.18785Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRailcard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/railcard.24a0b2d09212a1dddb9e7a5d0f387698.svg";